import { Align, Popup as KPopup, Offset } from '@progress/kendo-react-popup';
import { FC, useRef, useState } from 'react';

interface PopUpProps {
  children: React.ReactNode;
  content: React.ReactNode;
  anchorAlign?: Align;
  popupAlign?: Align;
  offset?: Offset;
  className?: string;
  show?: boolean;
  style?: React.CSSProperties | undefined;
}
const PopUp: FC<PopUpProps> = ({
  children,
  content,
  anchorAlign = { horizontal: 'right', vertical: 'bottom' },
  popupAlign = { horizontal: 'right', vertical: 'top' },
  offset,
  className = '',
  show: showPopUp = true,
  style,
}) => {
  const [show, setShow] = useState(false);
  const anchor = useRef<HTMLDivElement | null>(null);

  return (
    <div onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)} ref={anchor}>
      {children}
      {show && content ? (
        <KPopup
          style={style}
          anchor={offset ? null : anchor.current}
          anchorAlign={anchorAlign}
          popupAlign={popupAlign}
          show={show && showPopUp}
          animate={false}
          offset={offset}
          className={className}
        >
          {content}
        </KPopup>
      ) : undefined}
    </div>
  );
};

export default PopUp;
